import {Component, ElementRef, Injector, ViewChild} from '@angular/core';
import {GeneralPortfolioComponent} from "../general-portfolio/general-portfolio.component";
import moment from "moment";
import {PortfolioModel} from "../../shared/models/portfolio.model";
import {ColumnType} from "../../components/cim-datatable/cim-datatable.component";
import { deepCopy } from '@angular-devkit/core/src/utils/object';

import { forkJoin } from 'rxjs';
import { MaterialModule } from "src/app/app.materials";
import { InfoComponent } from "src/app/components/info/info.component";
import { CimDatepickerComponent } from "src/app/components/cim-datepicker/cim-datepicker.component";
import { BenchmarkSelectorComponent } from "src/app/components/benchmark-selector/benchmark-selector.component";
import { PortfolioReturnBarChartComponent } from "src/app/charts/portfolio-return-bar-chart/portfolio-return-bar-chart.component";
import { LineChartComponent } from "src/app/components/line-chart/line-chart.component";
import { RiskContributionColumnChartComponent } from "src/app/charts/risk-contribution-column-chart/risk-contribution-column-chart.component";
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CummulativeReturnChartComponent } from "src/app/charts/cummulative-return-chart/cummulative-return-chart.component";
import { DonutChartComponent } from "src/app/charts/donut-chart/donut-chart.component";
import { CimDatatableComponent } from "src/app/components/cim-datatable/cim-datatable.component";
import { ExportControlComponent } from "src/app/components/export-control/export-control.component";
import { PdfExportDialogComponent } from "src/app/components/pdf-export-dialog/pdf-export-dialog.component";
@Component({
  selector: 'app-overview',
    preserveWhitespaces: true,
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss'],
  standalone: true,
  imports: [MaterialModule, InfoComponent, CimDatepickerComponent, BenchmarkSelectorComponent, PortfolioReturnBarChartComponent, LineChartComponent, RiskContributionColumnChartComponent, CommonModule, RouterModule, FormsModule, CummulativeReturnChartComponent, DonutChartComponent, CimDatatableComponent, ExportControlComponent],
})
export class OverviewComponent extends GeneralPortfolioComponent{
  @ViewChild('portfolioCharacteristicsCard', { static: false }) portfolioCharacteristicsCard!: ElementRef;
  @ViewChild('valuationCard', { static: false }) valuationCard!: ElementRef;
  @ViewChild('returnCard', { static: false }) returnCard!: ElementRef;
  @ViewChild('riskCard', { static: false }) riskCard!: ElementRef;
  @ViewChild('portfolioConstituentsCard', { static: false }) portfolioConstituentsCard!: ElementRef;

  benchmarkCalculating = false;
  filter: any = {
    start: null,
    end: null
  }
  annualChartType = 'annualized_return';

  treeMapData: any[] = null;
  volatilityData: any = null;
  drawdownData: any[] = null;
  generalData: any[] = [];
  portfolioData: any[] = [];
  portfolioReturn: any = null;

  riskContributionData: any[] = [];
  benchmarkReturn: any = [];
  evaluationDataLoaded: any = false;
  marginalRiskContributionData: any[] = [{data:[]}];
  portfolioLoadedInService: PortfolioModel = null;

  chartsReady = false;

  negativeDataLabelsY = -4;
  positiveDataLabelsY = -20;


  sharpeChartData: any[] = [];
  annualChartOptions: any = {
    tooltip: {
      valueDecimals: 2,
      valueSuffix: ''
    },
    navigator: {
      enabled: false
    },
    zoom: {
      enabled: false,
    },
    rangeSelector: {
      enabled:false
    },
    scrollbar: {
      enabled: false
    },
    xAxis:{
      gridLineWidth: 0,
      minorGridLineWidth: 0
    },
    yAxis: {
      opposite: false,
      title: {
        text: 'Return',
        style: {
          textTransform: 'capitalize'
        }
      },
      gridLineWidth: 0,
      minorGridLineWidth: 0,
      plotLines: [{
        value: 0,
        width: 1,
        color: '#aaa',
        zIndex: 10
      }],
      stackLabels: {
        enabled: true,
      }
    },
    plotOptions: {
      series: {
        lineWidth: 2,
        groupPadding: 0.05,
        pointPadding: 0,
        dataGrouping: {
          enabled: false
        },
        dataLabels: {
          valueDecimals: 0,
          format: '{point.y:,.0f}%',
          allowOverlap: true,
        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.y}%</b>',
        },
      },
      column: {

        dataLabels: {
          enabled: true,
          format: '{y:.0f}%',
          inside: false,
          verticalAlign: 'top',
          align: 'center',
          crop: false,
          overflow: 'allow',
        }
      }
    },
  };

  portfolioConstituentsTableColumns: any[] = [
    {id: 'company_name', label: 'Asset', type: ColumnType.CompanyInfo},
    {id: 'type', label: 'Asset Class', type: ColumnType.Simple},
    {id: 'Weight', label: 'Weights', type: ColumnType.Percentage},
    {id: 'CAGR', label: 'CAGR', type: ColumnType.Percentage},
//    {id: 'returnContribution', label: 'Return Contribution', type: ColumnType.Percentage},
    {id: 'Volatility', label: 'Volatility', type: ColumnType.Percentage},
    {id: 'riskContribution', label: 'Risk Contribution', type: ColumnType.Percentage},
    {id: 'maxDrawdown', label: 'Max Drawdown', type: ColumnType.Percentage},
 //   {id: 'bestYear', label: 'Best Year', type: ColumnType.Percentage},
 //   {id: 'worstYear', label: 'Worst Year', type: ColumnType.Percentage},
    {id: 'Sharpe', label: 'Sharpe', type: ColumnType.Number2Decimal},
    // {id: 'sortino', label: 'Sortino', type: ColumnType.Number2Decimal},
  ];
  portfolioConstituentsTableData: any[] = [];
  evaluationData: any = {}
  isLoaded: boolean = false;

  initPage() {
    this.service.portfolio$.subscribe(res => this.portfolioLoadedInService = res);

    if (this.portfolio && this.portfolio.id) {
      this.setupData();
    }
  }


  setupData() {
    if (!this.treeMapData) {
      this.extractTreeMapData();
    }

    if (!this.portfolio.benchmark) {
      // no benchmark selected
    } else {
      this.service.selectBenchmark(this.portfolio.benchmark);
      this.selectedBenchmark = this.portfolio.benchmark;
    }

    forkJoin({
      e: this.service.getBenchmark(btoa(this.portfolio.benchmark), this.portfolio.id),
      c: this.service.fetchPerformancePlot(this.portfolio.id),
      v: this.service.fetchEvaluationData(this.portfolio.id),
    }).subscribe(val => {
      this.service.selectBenchmark(val.e);
      this.selectedBenchmark = val.e;

      this.evaluationData = val.v;
      this.plotData = this.convertToPercentages(val.c);
      this.calculateBenchmark(val.e);
      this.setGeneralData();
      this.updatePageWithBenchmark();
      this.isLoaded = true;
      this.afterPlotDataReceived();
    });
  }

  setGeneralData() {
    this.portfolio.symbol_performance.map((e: any) => {
      if (e.Ticker !== 'Portfolio' && e.Weight > 0) {
        let item = this.evaluationData.risk_contribution.find(a => a.Ticker ==  e.Ticker && a.Portfolio == 'baseline_portfolio');
        let riskContribution = 0;
        if (item) {
          riskContribution = item.risk_contribution;
        } else {
          console.log('missing item');
          console.log(e);
        }

        var companyName = '';
        var type = '';
        if(e.reference_table !== null) {
          companyName = e.reference_table.company_name ;
          type = e.reference_table.security_type_equity;
        } else if(e.etf_reference_table !== null) {
          companyName = e.etf_reference_table.name ;
          type = 'ETF';
        } else if(e.fund_reference_table !== null) {
          companyName = e.fund_reference_table.name ;
          type = 'FUND';
        } else {
          type = 'SHARE';
        }

        this.generalData.push({
          Ticker: e.Ticker,
          Weight: e.Weight,
          CAGR: e.CAGR,
          riskContribution: riskContribution,
///returnContribution: e.Weight * e.CAGR,
          company_name:  companyName,
          sector: e.reference_table !== null ?  e.reference_table.sector_fs: 'FUND' ,
          Sharpe: e.Sharpe,
          Volatility: e.Volatility,
          sortino: (this.treeMapData[0].data.find(a => a.name == e.Ticker).value -1.5) / e.Volatility,
          maxDrawdown: e["Max Drawdown"],
          type: type
        });

        // this.riskContributionData.categories.push(e.Ticker);
        // this.riskContributionData.series[0].data.push(riskContribution*100);
        // this.riskContributionData.series[1].data.push(e.Weight*100);
        this.riskContributionData.push({
          Ticker: companyName,
          riskContribution: riskContribution*100,
          Weight: e.Weight*100,
          Return: this.treeMapData[0].data.find(a => a.name == e.Ticker).value*e.Weight
        });

        this.marginalRiskContributionData[0].data.push({
          company: companyName,
          risk: parseFloat(((e.Weight * riskContribution)*100).toFixed(2)),
          return: parseFloat(((e.Weight * e.totalReturn)*100).toFixed(2))
        });
      } else {
        this.portfolioData.push({
          CAGR: e.CAGR,
          Volatility: e.Volatility,

          Sharpe: e.Sharpe,
          TrackingError: e.TrackingError,
          Beta: e.Beta,
          Alpha: e.Alpha,
          maxDrawdown: e["Max Drawdown"]
        })
      }
    });

  }

  checkSelectedBenchmark() {
    if (this.benchmark) {
      this.selectedBenchmark = this.portfolio.benchmark = this.benchmark;

      this.updatePageWithBenchmark();
    }
  }

  dayOfTheYear() {
    let date: Date = new Date();
    return (Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) - Date.UTC(date.getFullYear(), 0, 0)) / 24 / 60 / 60 / 1000;

  }
  afterPlotDataReceived() {
    let portfolioStart = new Date(this.portfolio.start_date).valueOf();
    let portfolioEnd = new Date(this.portfolio.end_date).valueOf();

    let copy = deepCopy(this.plotData.cumulative_returns.Portfolio.filter(function(e){return e[0] >= +portfolioStart && e[0] <= portfolioEnd}));
    var d = new Date(portfolioEnd);
    let dateOfTheYear = moment.utc(d).startOf('year').unix()*1000;
    let last_return_date = this.plotData.cumulative_returns.Portfolio.slice(-1)[0][0]; // need to calculate the 1month from here
    let last_return_date_1month = moment.utc(last_return_date).subtract(1, 'month').unix()*1000;

    this.drawdownData = this.calculateDrawdown(this.plotData.cumulative_returns, portfolioStart);

    this.portfolioReturn = {
      mnt: (
        (this.plotData.cumulative_returns.Portfolio.slice(-1)[0][1]-
        this.plotData.cumulative_returns.Portfolio.filter(function(e){return e[0] >= last_return_date_1month})[0][1]) // filter(function(e){return e[0] >= lastmonth})[0][1])
          /this.plotData.cumulative_returns.Portfolio.filter(function(e){return e[0] >= last_return_date_1month})[0][1])*100,
      totalReturn: ((copy.slice(-1)[0][1] - copy[0][1])/copy[0][1])*100,


      avgAnn: (this.plotData.annualized_return.Portfolio.reduce( (p,c) => p + c[1], 0) / this.plotData.annualized_return.Portfolio.length),


      ytd: ((this.plotData.cumulative_returns.Portfolio.slice(-1)[0][1]-
        this.plotData.cumulative_returns.Portfolio.filter(function(e){return e[0] < dateOfTheYear}).slice(-1)[0][1])
        /this.plotData.cumulative_returns.Portfolio.filter(function(e){return e[0] < dateOfTheYear}).slice(-1)[0][1])*100,


      cagrY1: this.plotData.daily_returns.Portfolio.slice(-365).reduce(function (sum, ret) {return sum + ret[1]}, 0),
      cagrY2:  (Math.pow((this.plotData.cumulative_returns.Portfolio.slice(-1)[0][1]/this.plotData.cumulative_returns.Portfolio.slice(-252*2)[0][1]),(1/2))-1)*100,
      cagrY3:  (Math.pow((this.plotData.cumulative_returns.Portfolio.slice(-1)[0][1]/this.plotData.cumulative_returns.Portfolio.slice(-252*3)[0][1]),(1/3))-1)*100,
      cagrY5: (Math.pow((this.plotData.cumulative_returns.Portfolio.slice(-1)[0][1]/this.plotData.cumulative_returns.Portfolio.slice(-252*5)[0][1]),(1/5))-1)*100,
    //  cagrY10: (Math.pow((1.98/1),(1/10))-1)*100
      cagrY10: (Math.pow((this.plotData.cumulative_returns.Portfolio.slice(-1)[0][1]/this.plotData.cumulative_returns.Portfolio.slice(-252*10)[0][1]),(1/10))-1)*100,

    }

    this.initVolatilityChart()
    this.chartsReady = false;
    setTimeout(() => {
      this.chartsReady = true;
      this.initAnnualSharpeChart();
    }, 1000);
  }


  initVolatilityChart() {
    this.volatilityData = [];
    if (this.plotData && this.plotData.rolling_std_deviation) {
      this.volatilityData = {
        title: '',
        series: [{
          name: "Portfolio",
          type: 'line',
          data: this.plotData.rolling_std_deviation['Portfolio']
        }]
      };
    }
  }

  initAnnualSharpeChart() {

    let portfolioStart = new Date(this.portfolio.start_date).valueOf();
    let portfolioEnd = new Date(this.portfolio.end_date).valueOf();
    this.sharpeChartData = [];
    if (this.plotData[this.annualChartType]) {
      const copy = deepCopy(this.plotData[this.annualChartType]['Portfolio']
        .filter((e) => e[0] >= portfolioStart && e[0] <= portfolioEnd));

      this.sharpeChartData.push({
        name: 'Portfolio',
        data: copy.map(d => {
          const x = moment.utc(d[0]).startOf('year').unix()*1000;
          const y = d[1];
          return {
            x,
            y,
            dataLabels: {
              // push positive labels above bars, negative below bars
              y: y >= 0 ? this.positiveDataLabelsY : this.negativeDataLabelsY
            }
          };
        }),
        type: 'column'
      });
    }

    if (this.benchmark) {
       var benchmarkData: any[] = [];
       let value = 0;
      this.benchmark.perfAnn.map((d: any) => {
        var date = moment.utc(d.year+"-01-01").unix()*1000;
        if (date >= portfolioStart && date <= portfolioEnd) {
          if (this.annualChartType == 'annualized_sharpe')  value =  d.sharpe;
          if (this.annualChartType == 'annualized_return') value = d.return;
          if (this.annualChartType == 'annualized_std_deviation') value = d.volatility;

          benchmarkData.push({
            x: date,
            y: value,
            dataLabels: {
              y: value >= 0 ? this.positiveDataLabelsY : this.negativeDataLabelsY
            }
          })
        }
      })
      this.sharpeChartData.push({
        name: this.benchmark.index_name_short ?? 'Benchmark',
        data: benchmarkData,
        type: 'column'
      })
    }
    if (this.annualChartType === 'annualized_return') {
      // return YTD calculation is different in the R model, so we need to calculate it here to show consistent data through the UI
      if (this.portfolioReturn && this.portfolioReturn.ytd && this.sharpeChartData[0].data.length) {
        (this.sharpeChartData[0].data[this.sharpeChartData[0].data.length - 1] as any).y = this.portfolioReturn.ytd; // update the last data point with the YTD return
      }
      if (this.benchmarkReturn && this.benchmarkReturn.ytd && this.sharpeChartData[1]?.data?.length) {
        (this.sharpeChartData[1].data[this.sharpeChartData[1].data.length - 1] as any).y = this.benchmarkReturn.ytd; // update the last data point with the YTD return
      }
      this.annualChartOptions.yAxis.title.text = 'Return';
      this.annualChartOptions.yAxis.labels = {format: '{text}%'};
      this.annualChartOptions.plotOptions.series.tooltip = '{series.name}: <b>{point.y}%</b>';
      this.annualChartOptions.tooltip.valueSuffix = '%';
      this.annualChartOptions.plotOptions.column.dataLabels.format = '{y:,.0f}%';
    } else if (this.annualChartType === 'annualized_std_deviation') {
      this.annualChartOptions.yAxis.title.text = 'Volatility';
      this.annualChartOptions.yAxis.labels = {format: '{text}%'};
      this.annualChartOptions.plotOptions.series.tooltip = '{series.name}: <b>{point.y}%</b>';
      this.annualChartOptions.tooltip.valueSuffix = '%';
      this.annualChartOptions.plotOptions.column.dataLabels.format = '{y:,.0f}%';
    } else {
      this.annualChartOptions.yAxis.title.text = 'Sharpe Ratio';
      this.annualChartOptions.yAxis.labels = {format: '{text}'};
      this.annualChartOptions.plotOptions.series.tooltip = '{series.name}: <b>{point.y}</b>';
      this.annualChartOptions.tooltip.valueSuffix = '';
      this.annualChartOptions.plotOptions.column.dataLabels.format = '{y:,.2f}';
    }
  }

  setColor(value, min, max) {
    let color = '#286E28';
    let percent = 100;

    if (value < 0) {
      color = '#c60000';
      percent = (Math.abs(value) / Math.abs(min)) * 100;
    } else {
      percent = (Math.abs(value) / Math.abs(max)) * 100;
    }
    return this.util.shadeColor(color, 100 - percent);
  }

  setColors(list, min, max) {
    Object.entries(list).map(([key,data]:[string,any]) => {
      list[key].color = this.setColor(data.realValue, min, max);
    })
  }

  extractTreeMapData() {
    let portfolioStart = new Date(this.portfolio.start_date).valueOf();
    let portfolioEnd = new Date(this.portfolio.end_date).valueOf();
    if (this.portfolio.treemap_plot && this.portfolio.treemap_plot.length) {
      let return_data = []; //hist_returns_annualized
      let std_data = []; //std_dev_annualized

      let minReturn = 99999;
      let maxReturn = -99999;
      let minVolatility = 99999;
      let maxVolatility = -99999;

      Object.entries(this.portfolio.treemap_plot).map(([key,data]:[string,any]) => {
        let company = this.portfolio.security_overviews[data.Ticker] || null;
        let companyName = company ? company.company_name : this.getFundName(data.Ticker);
        let type = company ? company.security_type_equity : '';
        if (data.historical_returns) {
          if (minReturn > +data.historical_returns) {
            minReturn = +data.historical_returns;
          }
          if (maxReturn < +data.historical_returns) {
            maxReturn = +data.historical_returns;
          }

          return_data[data.Ticker] = {
            name: data.Ticker,
            company: companyName,
            value: +(data.historical_returns * 100).toFixed(2),
            realValue: +(data.historical_returns * 100).toFixed(2),
            country: data.country_hq_name,
            industry: data.industry_fs,
            sector: data.sector_fs,
            type,
          }
        }
        if (data.volatility) {
          if (minVolatility > +data.volatility) {
            minVolatility = +data.volatility;
          }
          if (maxVolatility < +data.volatility) {
            maxVolatility = +data.volatility;
          }
          std_data[data.Ticker] = {
            name: data.Ticker,
            company: companyName,
            value: +(Math.abs(data.volatility) * 100).toFixed(2),
            realValue: +(data.volatility * 100).toFixed(2),
            country: data.country_hq_name,
            industry: data.industry_fs,
            sector: data.sector_fs,
            type,
          }
        }
      });

      this.setColors(return_data, minReturn * 100, maxReturn * 100);
      this.setColors(std_data, minVolatility * 100, maxVolatility * 100);

      this.treeMapData = [
        {
          name: "Annualized Return",
          data: Object.values(return_data)
        },
        {
          name: "Annualized Volatility",
          data: Object.values(std_data)
        }
      ];
    }

  }

  onDateChange(prop) {
    this.filter[prop] = this.filter[prop].format('YYYY-MM-DD');
  }


  updatePageWithBenchmark() {
    let portfolioStart = new Date(this.portfolio.start_date).valueOf();
    let portfolioEnd = new Date(this.portfolio.end_date).valueOf();
    var d = new Date(portfolioEnd);
    let dateOfTheYear = moment.utc(d).startOf('year').unix()*1000;
    let last_return_date = this.plotData.cumulative_returns.Portfolio.slice(-1)[0][0]; // need to calculate the 1month from portfolio last available date here

    let last_return_date_1month = moment.utc(last_return_date).subtract(1, 'month').unix()*1000;
    if(this.benchmark.cumulative_returns){
      var copy = deepCopy(this.benchmark.cumulative_returns.filter(function(e){return e.date >= +portfolioStart && e.date <= +portfolioEnd}));

     let timediff = ((copy.slice(-1)[0].date-copy[0].date)/(1000*60*60*24))/365.25;

      this.benchmarkReturn = {
        mnt: ((this.benchmark.cumulative_returns.slice(-1)[0].value-
          this.benchmark.cumulative_returns.filter(function(e){return e.date >= last_return_date_1month})[0].value)
         /this.benchmark.cumulative_returns.filter(function(e){return e.date >= last_return_date_1month})[0].value)*100,
        totalReturn: ((copy.slice(-1)[0].value - copy[0].value)/copy[0].value)*100,
        avgAnn: (this.benchmark.annualized_return.reduce( (p,c) => p + c[1], 0) / this.benchmark.annualized_return.length),
        ytd:  ((copy.slice(-1)[0].value-
          copy.filter(function(e){return e.date < dateOfTheYear}).slice(-1)[0].value)
          /copy.filter(function(e){return e.date < dateOfTheYear}).slice(-1)[0].value)*100,
        cagrY1:  (Math.pow((copy.slice(-1)[0].value/copy[0].value),(1/ timediff))-1)*100,//(Math.pow((this.benchmark.cumulative_returns.slice(-1)[0].value/this.benchmark.cumulative_returns.slice(-252)[0].value),(1/2))-1)*100,
        cagrY2:  (Math.pow((this.benchmark.cumulative_returns.slice(-1)[0].value/copy.filter(function(e){return e.date >= (moment.utc(d).unix() -  2*365*3600*24)*1000}).slice(-252*2)[0].value),(1/2))-1)*100,
        cagrY3:  (Math.pow((this.benchmark.cumulative_returns.slice(-1)[0].value/copy.filter(function(e){return e.date >= (moment.utc(d).unix() -  3*365*3600*24)*1000}).slice(-252*3)[0].value),(1/3))-1)*100,
        cagrY5: (Math.pow((this.benchmark.cumulative_returns.slice(-1)[0].value/copy.filter(function(e){return e.date >= (moment.utc(d).unix() -  5*365*3600*24)*1000}).slice(-252*5)[0].value),(1/5))-1)*100,
      //  cagrY10: (Math.pow((1.98/1),(1/10))-1)*100
        cagrY10: (Math.pow((this.benchmark.cumulative_returns.slice(-1)[0].value/copy.filter(function(e){return e.date >= (moment.utc(d).unix() -  10*365*3600*24)*1000}).slice(-252*10)[0].value),(1/10))-1)*100

      }
  }
    this.initAnnualSharpeChart();

    // portfolio benchmark
    if(this.selectedBenchmark && typeof this.selectedBenchmark.id == 'number'){
      this.benchmarkCalculating = false;
    }
  };

  reloadPortfolioCalculatedData() {
    this.service.viewItem(this.portfolio.id).subscribe((resp: any) => {
      if (resp.id) {
        this.portfolio.performance_summary = resp.performance_summary;
        this.portfolio.symbol_performance = resp.symbol_performance;

        this.benchmarkCalculating = false;
      }
    })
  }

  onBenchmarkSelect(benchmark) {
    if (benchmark && benchmark.id) {
      this.service.notificationService.open("Benchmark changed. Please click save to apply.")
      this.selectedBenchmark =  benchmark;
      this.portfolio.benchmark =benchmark.name;
      this.benchmarkCalculating = true;
     // super.onBenchmarkSelect();

    } else {
   //   this.selectedBenchmark = null;
   //   this.benchmark = null;
      this.updatePageWithBenchmark();
    }
  }

  onCalculateReturnsClick() {
    if (
      !this.portfolio.start_date ||
      !this.portfolio.end_date
    ) {
      return this.service.notificationService.open('Fill the start and end dates.')
    }
      this.portfolio.needReload = true;
      this.handleReturnCalculationRequest('Your backtest is running');
    }


  onDrawdownDatechange(event) {
  }

  exportPortfolioCharacteristicsCard(): void {
    const element = document.querySelector('#description-card .row .col-md-6:first-child mat-card.mb-2') as HTMLElement;
    this.handleCardExport('portfolioCharacteristics', element, `portfolio-characteristics-${this.portfolio?.name || 'export'}.jpeg`);
  }

  exportValuationCard(): void {
    const element = document.querySelector('#description-card .row .col-md-6:last-child mat-card.mb-2') as HTMLElement;
    this.handleCardExport('valuation', element, `valuation-${this.portfolio?.name || 'export'}.jpeg`);
  }

  exportReturnCard(): void {
    const element = document.querySelector('#description-card .row:last-child .col-md-6:first-child mat-card') as HTMLElement;
    this.handleCardExport('return', element, `return-${this.portfolio?.name || 'export'}.jpeg`);
  }

  exportRiskCard(): void {
    const element = document.querySelector('#description-card .row:last-child .col-md-6:last-child mat-card') as HTMLElement;
    this.handleCardExport('risk', element, `risk-${this.portfolio?.name || 'export'}.jpeg`);
  }

  exportPortfolioConstituentsCard(): void {
    const element = document.getElementById('portfolio_constituents');
    this.handleCardExport('portfolioConstituents', element, `portfolio-constituents-${this.portfolio?.name || 'export'}.jpeg`);
  }

  exportCumulativeReturnsChart(): void {
    const element = document.getElementById('cumulative_returns');
    this.handleCardExport('cumulativeReturns', element, `cumulative-returns-${this.portfolio?.name || 'export'}.jpeg`);
  }
  exportAnnualPerformanceChart(): void {
    const element = document.getElementById('annual_performance');
    this.handleCardExport('annualPerformance', element, `annual-performance-${this.portfolio?.name || 'export'}.jpeg`);
  }
  exportWeightsPerformanceChart(): void {
    const element = document.getElementById('weights_performance');
    this.handleCardExport('weightsPerformance', element, `weights-performance-${this.portfolio?.name || 'export'}.jpeg`);
  }
  exportSummaryRiskContributionChart(): void {
    const element = document.getElementById('summary-risk-contribution-chart');
    this.handleCardExport('summaryRiskContribution', element, `summary-risk-contribution-${this.portfolio?.name || 'export'}.jpeg`);
  }

  onExportPdf(): void {
    let targetPortfolio = 'efficient_portfolio_max_sharpe_ratio';

    if (this.optim) {
      targetPortfolio = this.optim.toString();
    } else if (this.optimizationData && this.optimizationData.optim_parameters && this.optimizationData.optim_parameters.optim_performance) {
      targetPortfolio = this.optimizationData.optim_parameters.optim_performance;
    }

    this.dialog.open(PdfExportDialogComponent, {
      data: {
        portfolioId: this.portfolio.id,
        portfolioName: this.portfolio.name,
        targetPortfolio: targetPortfolio
      },
      maxWidth: '1200px',
      minWidth: '1100px',
    });
  }
}
